// noinspection JSUnusedLocalSymbols

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getNowString = (_diff: any) => {
  return 'σχεδόν τώρα';
};

export const getPastDiffString = (diff: any) => {
  const { seconds, minutes, hours, months, days, years } = diff;
  if (seconds <= 5) {
    return 'πριν μερικά δευτερόλεπτα';
  } else if (seconds <= 59) {
    return 'πριν ' + seconds + ' δευτερόλεπτα';
  } else if (seconds <= 90) {
    return 'περίπου πριν ένα λεπτό';
  }
  if (minutes <= 45) {
    return 'πρίν ' + minutes + ' λεπτά';
  } else if (minutes <= 90) {
    return 'πριν μια ώρα';
  }
  if (hours <= 22) {
    return 'πριν ' + hours + ' ώρες';
  } else if (hours <= 36) {
    return 'πριν μια μέρα';
  }
  if (days <= 25) {
    return 'πριν ' + days + ' μέρες';
  } else if (days <= 45) {
    return 'πριν ενα μήνα';
  }
  if (days <= 345) {
    return 'πριν ' + months + ' μήνες';
  } else if (days <= 545) {
    return 'πριν ενα χρόνο';
  }
  return 'πριν ' + years + ' χρόνια';
};

export const getFutureDiffString = (diff: any) => {
  const { seconds, minutes, hours, months, days, years } = diff;
  if (seconds <= 59) {
    return 'σε ' + seconds + ' δευτερόλεπτα';
  }
  if (seconds <= 90) {
    return 'σε ενα λεπτό';
  } else if (minutes <= 59) {
    return 'σε ' + minutes + ' λεπτά';
  }
  if (minutes <= 90) {
    return 'σε μια ώρα';
  } else if (hours <= 22) {
    return 'σε ' + hours + ' ώρες';
  }
  if (hours <= 36) {
    return 'σε μια μέρα';
  } else if (days <= 25) {
    return 'σε ' + days + ' μέρες';
  }
  if (days <= 45) {
    return 'σε ενα μήνα';
  } else if (days <= 345) {
    return 'σε ' + months + ' μήνες';
  }
  if (days <= 545) {
    return 'σε ένα χρόνο';
  }
  return 'σε ' + years + ' χρόνια';
};
